import { useEffect } from 'react';

import { clearPatientKeysFromIDB } from '../../crypto-module/clear-patient-keys-from-idb.js';
import type { CancelState } from '../state-machine-feature/cancel-state.type.js';

const END_SCREENS: ReadonlySet<CancelState['screen']> = new Set([
  'SUCCESS',
  'BUSINESS_ERROR',
  'TECHNICAL_ERROR',
]);

/**
 * Beobachtet den `screen` aus der State-Machine. Sobald die App in einen
 * End-State wechselt (SUCCESS, BUSINESS_ERROR, TECHNICAL_ERROR), wird die
 * IDB komplett gelöscht.
 *
 * Idempotent: erneute Renders im selben End-State triggern keinen erneuten
 * Cleanup-Aufruf (`useEffect`-Dep auf den Screen-Namen).
 *
 * Cleanup-Fehler werden bewusst geschluckt — eine geblockte Löschung (zweiter
 * Tab) darf den UI-Fluss nicht crashen; der Sicherheitsgewinn ist primär
 * „best effort, single tab".
 */
export function useEndStateCleanup(screen: CancelState['screen']): void {
  useEffect(() => {
    if (!END_SCREENS.has(screen)) {
      return;
    }
    void runCleanup();
  }, [screen]);
}

async function runCleanup(): Promise<void> {
  try {
    await clearPatientKeysFromIDB();
  } catch {
    // Cleanup-Fehler dürfen den End-State nicht verschlucken.
  }
}
